import { NdtStep } from "./helpers";

export default function() {
    return NdtStep('step5a', 'Step 5a: Are benefits disproportionately enjoyed by HCEs', {
        nextComponent: () => 'step6',
        passed() {
            let { grossCompensationHces, grossCompensationNonHces, participatingHces, participatingNonHces  } = this;

            if(grossCompensationHces ==  0 || participatingHces == 0) return true;

            let hceUtilization = Math.round(participatingHces / grossCompensationHces)
            let nonHceUtilization = grossCompensationNonHces == 0 ? 100 : Math.round(participatingNonHces / grossCompensationNonHces);

            return hceUtilization < nonHceUtilization;
        },
        details() {
             return [
                 { question: 'Step 5a: Total annual gross compensation for all ELIGIBLE HCEs', result: `$${this.grossCompensationHces}`},
                 { question: 'Total annual gross compensation for all ELIGIBLE non-HCEs', result: `$${this.grossCompensationNonHces}`},
                 { question: 'Total annual cost of the benefits enjoyed under the plan by all PARTICIPATING HCEs', result: `$${this.participatingHces}`},
                 { question: 'Total annual cost of the benefits enjoyed under the plan by all PARTICIPATING non-HCEs', result: `$${this.participatingNonHces}`},
             ]
        },
        nextEnabled() {
            var props = ['grossCompensationHces', 'grossCompensationNonHces', 'participatingHces', 'participatingNonHces']
            return props.every(p => this.answers[p] != null);
        },
        template: `
            <div>
                <q-title :text="question" />
                <help-block label="NOTE: Based on your answer to the previous question, the plan does not qualify for the Safe Harbor for the Contributions &amp; Benefits Test. For this reason, you will need aggregate compensation information as well as aggregate benefit information for all eligible HCEs and non-HCEs to answer this question." />
                <help-block label='NOTE: "total cost of all benefits" = Total benefit premiums paid by BOTH the employee and the employer for all pre-taxed benefits' />
                <div class="px-2 row">
                    <amf-input label="Total annual gross compensation for all ELIGIBLE HCEs" inputType="number" v-model="answers.grossCompensationHces" aggressive/>
                </div>
                <div class="px-2 row">
                    <amf-input label="Total annual gross compensation for all ELIGIBLE non-HCEs" inputType="number" v-model="answers.grossCompensationNonHces" aggressive/>
                </div>
                <div class="px-2 row">
                    <amf-input label="Total annual cost of the benefits enjoyed under the plan by all PARTICIPATING HCEs" inputType="number" v-model="answers.participatingHces" aggressive/>
                </div>
                <div class="px-2 row">
                    <amf-input label="Total annual cost of the benefits enjoyed under the plan by all PARTICIPATING non-HCEs" inputType="number" v-model="answers.participatingNonHces" aggressive/>
                </div>
            </div>
        `,
    })
}


// WEBPACK FOOTER //
// ./src/shared/Nondiscrimination/POP/step5a.js